/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const ThemeFunc = function () {

	const isScrolledIntoView = (el) => {
		var rect = el.getBoundingClientRect();
		var elemTop = rect.top;
		var elemBottom = rect.bottom;
		// Only completely visible elements return true:
		// var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
		// Partially visible elements return true:
		isVisible = elemTop < window.innerHeight && elemBottom >= 0;
		return isVisible;
	}


	const isMobile = () => {
		if (window.matchMedia('(any-hover: none)').matches || document.documentElement.clientWidth < 768) {
			return true;
		}
		return false;
	};

	const PredictiveSearch = () => {
		const $searchInput = document.querySelector('.Search__SearchBar input[name="q"]');
		const $searchDefaultWrapper = document.querySelector('.Search__Results-default');
		const $searchWrapper = document.querySelector('.Search__Results');
		const $searchResultWrapper = document.querySelector('.Search__Results--content');
		const $resultCount = document.querySelector('.Search__Results .result-count');

		let timeout;

		var keyUpEventHandler = function (event) {
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				let q = $searchInput.value;
				if (q == '') {
					$searchDefaultWrapper.setAttribute('aria-hidden', false);
					$searchWrapper.setAttribute('aria-hidden', true);

					$searchResultWrapper.innerHTML = '';
					$resultCount.innerHTML = '';
				}
				else {
					$searchDefaultWrapper.setAttribute('aria-hidden', true);
					$searchWrapper.setAttribute('aria-hidden', false);
					searchProducts(q);
				}
			}, 500);
		}

		$searchInput.addEventListener('keydown', () => {
			setTimeout(() => {
				keyUpEventHandler();
			})
		})

		const searchProducts = (searchString) => {
			const data = {
				siteId: window.ssId,
				q: searchString,
				resultsFormat: 'native',
				includedFacets: '',
			}
			let searchEndpoint = 'https://api.searchspring.net/api/search/autocomplete.json';
			let url = `${searchEndpoint}?includedFacets=&bgfilter.ss_secret=0`;
			$.ajax({
				url,
				type: 'POST',
				data,
				success: (res) => {
					const results = res.results;
					let exclude_count = 0;
					if (results.length > 0) {
						$searchResultWrapper.innerHTML = '';
						results.forEach((productInfo) => {
							if (window.excludeProducts.includes(productInfo.handle)) {
								exclude_count++;
								return;
							}
							$searchResultWrapper.append(ProductGrid.buildItem(productInfo, 'grid', false, false, 4, 2));
						})
						$resultCount.innerHTML = `${results.length - exclude_count} results`;
					}
					$resultCount.setAttribute('data-result-count', `${results.length - exclude_count}`);
				},
			});
		}
	}

	const IconTextSlider = () => {

		if (!document.querySelector('.section-icon-text-slider')) {
			return false;
		}

		let slider_len = document.querySelectorAll('.slider-buttons .slider-button').length;
		let slideTimer;

		const rotateSlider = () => {
			let index = parseInt(document.querySelector(`.slider-buttons .slider-button.active`).getAttribute('data-index'));
			index++;
			if (index > slider_len) {
				index = 1;
			}
			document.querySelector(`.slider-buttons .slider-button[data-index="${index}"]`).click();
			// slideTimer = setTimeout(() => {
			// 	rotateSlider();
			// }, 5000);
		}

		// rotateSlider();

		const IconTextSection = document.querySelector('.section-icon-text-slider');

		IconTextSection.querySelectorAll('.flickity-prev-next-button').forEach((button) => {
			button.addEventListener('click', () => {
				let activeIdx = IconTextSection.querySelector('.slider-button.active').getAttribute('data-index');
				let targetIdx = parseInt(activeIdx);
				if(button.getAttribute('data-action') == 'next') {
					targetIdx ++;
				}
				else {
					targetIdx --;
				}
				if(targetIdx < 1) {
					targetIdx = slider_len;
				}
				if(targetIdx > slider_len) {
					targetIdx = 1;
				}
				IconTextSection.querySelector(`.slider-buttons .slider-button[data-index="${targetIdx}"]`).click();
			})
		})

		document.querySelectorAll('.section-icon-text-slider').forEach(($section) => {
			$section.querySelectorAll('.slider-button').forEach(($button) => {
				$button.addEventListener('click', () => {
					var index = $button.getAttribute('data-index');
					$section.querySelector('.slider-button.active').classList.remove('active');
					$button.classList.add('active');

					const $currentItem = $section.querySelector('.slider-item.active');
					const $newItem = $section.querySelector(`.slider-item[data-index="${index}"]`);
					$currentItem.classList.remove('active');
					$newItem.classList.add('active');
					setTimeout(() => {
						$currentItem.classList.remove('visible');
						$newItem.classList.add('visible');
					}, 300);
				})
			})
		})

	}

	const VideoInviewPlay = () => {
		document.querySelectorAll('.embed-wrapper').forEach(($embed) => {
			if ($embed.getAttribute('data-autoplay') != 'true') {
				return;
			}
			var $iframe = $embed.querySelector('iframe');
			var $video = $embed.querySelector('video');
			if (isScrolledIntoView($embed)) {
				if ($iframe) {
					if ($iframe.getAttribute('data-play') == 'true') {
						return;
					}
					var src = $iframe.getAttribute('src');
					if (!src.includes('autoplay')) {
						if (src.includes('?')) {
							src += '&autoplay=1';
						}
						else {
							src += '?autoplay=1'
						}
						if (!src.includes('muted=1')) {
							src += '&muted=1';
						}
					}
					$iframe.setAttribute('src', src);
					$iframe.setAttribute('data-play', 'true');
				}
				if ($video) {
					$video.play();
				}
			}
			else {
				if ($iframe) {
					var src = $iframe.getAttribute('src');
					src = src.replace('&autoplay=1', '').replace('?autoplay=1&', '?').replace('?autoplay=1', '?');
					$iframe.setAttribute('src', src);
					$iframe.setAttribute('data-play', 'false');
				}
				if ($video) {
					$video.pause();
				}
			}
		})
	}

	const SideMenuPos = (e) => {
		const $announcement = document.querySelector('#section-announcement');
		const $header = document.querySelector('#shopify-section-header');
		let scrollTop = document.documentElement.scrollTop;
		let height = 0;
		if ($announcement) {
			height += $announcement.offsetHeight;
		}
		if ($header) {
			// height += $header.offsetHeight;
		}
		if (scrollTop > height) {
			scrollTop = $header.offsetHeight;
		}
		else {
			scrollTop = height - scrollTop + $header.offsetHeight;
		}
		const $sidebar = document.querySelector('#sidebar-menu');
		if ($sidebar) {
			$sidebar.style.top = scrollTop + 'px';
		}
	}


	let isATC_passed = false;

	const ProductStickyATC = () => {
		const $atcButton = document.querySelector('.Product__Wrapper .ProductForm__BuyButtons .ProductForm__AddToCart');
		const $stickyATC = document.querySelector('.prodcut-sticky-atc');
		let scrollTop = document.documentElement.scrollTop;
		// let atcTop = $atcButton.offsetTop;

		if ($atcButton && $stickyATC) {
			if (isScrolledIntoView($atcButton)) {
				isATC_passed = true;
				$stickyATC.classList.remove('visible');
				setTimeout(() => {
					$stickyATC.classList.add('hidden');
				}, 200);
			}
			else {
				// if(isATC_passed) {
				$stickyATC.classList.remove('hidden');
				setTimeout(() => {
					$stickyATC.classList.add('visible');
				}, 200);
				// }
				// if(scrollTop > atcTop + 47) {
				//     isATC_passed = true;

				// }
				// else {
				//     if(isATC_passed) {
				//         $stickyATC.classList.remove('hidden');
				//         setTimeout(() => {
				//             $stickyATC.classList.add('visible');
				//         }, 10);
				//     }
				// }
			}
		}
	}


	const ProductStickyATCTrigger = () => {
		const $formATCButton = document.querySelector('.section-main-product .ProductForm__BuyButtons .ProductForm__AddToCart');
		const $stickyATCButton = document.querySelectorAll('.prodcut-sticky-atc button.sticky-atc-trigger');
		$stickyATCButton.forEach((atcBtn) => {
			atcBtn.addEventListener('click', () => {
				if (atcBtn.getAttribute('data-variant') == 'true' && isMobile()) {
					atcBtn.closest('.prodcut-sticky-atc').classList.toggle('variant-open');
				}
				else {
					$formATCButton.click();
				}
			})
		})
		document.querySelectorAll('.prodcut-sticky-atc li').forEach(($li) => {
			$li.addEventListener('click', () => {
				if ($li.classList == 'disabled') {
					return;
				}
				document.querySelector(`.section-main-product .ProductForm__Variants input[value="${$li.getAttribute('data-value')}"]`).click();
				setTimeout(() => {
					$formATCButton.click();
					$li.closest('.section-main-product .prodcut-sticky-atc.variant-open').classList.remove('variant-open');
				}, 100);
			})
		})
		document.querySelectorAll('.sticky-variant-swatch button').forEach((variantBtn) => {
			variantBtn.addEventListener('click', () => {
				var btnEl = variantBtn.closest('.sticky-toolbar').querySelector('.sticky-atc-trigger .sticky-atc-price');
				btnEl.innerText = variantBtn.getAttribute('data-price');
				document.querySelector('.sticky-variant-swatch button.active').classList.remove('active');
				variantBtn.classList.add('active');

				var $btnStickyATC = variantBtn.closest('.sticky-toolbar').querySelector('.sticky-atc-trigger');
				var $btnStickySoldout = variantBtn.closest('.sticky-toolbar').querySelector('.sticky-atc-soldout');
				if(variantBtn.classList.contains('soldout')) {
					$btnStickyATC.classList.add('hidden');
					$btnStickySoldout.classList.remove('hidden');
				}
				else {
					$btnStickyATC.classList.remove('hidden');
					$btnStickySoldout.classList.add('hidden');
				}

				var mainVariant = document.querySelector(`.Product__Wrapper .ProductForm__Variants input[value="${variantBtn.getAttribute('data-value')}"]`);
				if(mainVariant) {
					mainVariant.click();
				}
			})
		})
	}


	const ProductItemATC = (wrapper, c_validate) => {
		// if (c_validate) {
		// 	if (document.body.classList.contains('template-collection')) {
		// 		return false;
		// 	}
		// }

		let $wrapper = document;
		if (wrapper != null) {
			$wrapper = document.querySelector(wrapper);
		}

		$wrapper.querySelectorAll('.product-form-atc-trigger').forEach(($button) => {
			if (isMobile()) {
				$button.addEventListener('click', (e) => {
					console.log("Triggering ATC on mobile...");
					e.preventDefault();
					addItemEvent(e, $button, 'click');
				})
			}
			else {
				$button.addEventListener('click', (e) => {
					console.log("Triggering ATC on desktop...");
					e.preventDefault();
					const $buttonWrapper = $button.closest('.ProductForm__BuyButtons');
					if (!$button.classList.contains('has-variant') || !isMobile()) {
						// $buttonWrapper.querySelector('.ProductForm__AddToCart').click();
						// var target_item = $buttonWrapper.querySelector('.ProductForm__Variants ul li:not(.disabled)');
                        var target_item = $buttonWrapper.querySelector('.ProductForm__Variants ul li.selected');
						if(target_item) {
							target_item.click();
						}
					}
				})
				// $button.addEventListener('mouseover', (e) => {
				// 	console.log(333);
				// 	e.preventDefault();
				// 	addItemEvent(e, $button);
				// })
			}
		})

		document.addEventListener('change', (e) => {
			let rcInfo = e.target.closest('.Product__RechargeInfo');
			if(rcInfo) {
				if(rcInfo.querySelector('[data-product-card-recharge]').checked) {
					rcInfo.classList.add('enabled');
				}
				else {
					rcInfo.classList.remove('enabled');
				}
			}
		})

		$wrapper.querySelectorAll('.ProductItem__Wrapper .product-item-variants li').forEach(($variant) => {
			$variant.addEventListener('click', () => {
				const $form = $variant.closest('form');
				$form.querySelector('select').value = $variant.getAttribute('data-variant-id');
				$form.querySelector('.ProductForm__AddToCart').click();
			})
		})

		if (isMobile()) {
			document.addEventListener('click', (e) => {
				if (!(e.target.classList.contains('product-form-atc-trigger') && e.target.getAttribute('data-variant-expanded') == 'true')) {
					hideItemVariants();
				}
				else {
				}
			})
		}
		else {
			let is_v_open = false;
			// document.querySelectorAll('.ProductForm__Variants').forEach(($from_v) => {
			// 	$from_v.addEventListener('mouseover', () => {
			// 		is_v_open = true;
			// 	})
			// 	$from_v.addEventListener('mouseleave', () => {
			// 		is_v_open = false;
			// 	})
			// })

			let activeFormEl = null;
			document.addEventListener('mouseover', (e) => {
				let target = e.target;
				let formEl = null;
				if(target.classList.contains('ProductForm__BuyButtons') || target.closest('.ProductForm__BuyButtons')) {
					formEl = target.closest('.ProductForm__BuyButtons') || target;
					if(formEl.querySelector('.product-form-atc-trigger') && formEl.querySelector('.product-form-atc-trigger').classList.contains('has-variant')) {
						if(!formEl.classList.contains('show-variant')) {
							formEl.classList.add('show-variant');
							activeFormEl = formEl;

							document.querySelectorAll('.ProductForm__BuyButtons.show-variant').forEach((_form) => {
								if(formEl !== _form) {
									_form.classList.remove('show-variant');
								}
							})
						}
					}
				}
				else {
					if(activeFormEl != null) {
						activeFormEl.classList.remove('show-variant');
					}
				}
				// if (!(e.target.classList.contains('product-form-atc-trigger') && e.target.getAttribute('data-variant-expanded') == 'true')) {
				// 	if (!is_v_open) {
				// 		hideItemVariants();
				// 	}
				// }
				// else {
				// }

			})
		}

		function addItemEvent(e, $button, event) {
			hideItemVariants(e.target);
			const $buttonWrapper = $button.closest('.ProductForm__BuyButtons');
			if ($button.classList.contains('has-variant')) {
				$buttonWrapper.classList.toggle('show-variant');
				if ($button.getAttribute('data-variant-expanded') == 'true') {
					$button.setAttribute('data-variant-expanded', 'false');
				}
				else {
					$button.setAttribute('data-variant-expanded', 'true');
				}
			}
			else {
				if (event == 'click') {
					$buttonWrapper.querySelector('.ProductForm__AddToCart').click();
				}
			}
		}

		function hideItemVariants(_button) {
			document.querySelectorAll('.ProductForm__BuyButtons.show-variant').forEach(($buttonWrapper) => {
				const $button = $buttonWrapper.querySelector('.product-form-atc-trigger');
				$buttonWrapper.classList.remove('show-variant');
				if ($button != _button) {
					$button.setAttribute('data-variant-expanded', 'false');
				}
			})
		}
	}


	const CollapseAccountNav = () => {
		let $navToggle = document.querySelector('.account-nav-toggle');
		if ($navToggle) {
			$navToggle.addEventListener('click', () => {
				$navToggle.closest('.mobile-nav').classList.toggle('active');
			})
		}
	}

	const yotpoLinkClickHandler = (target) => {
		target.addEventListener('click', () => {
			let $reviewWidget = document.querySelector('.yotpo-reviews-main-widget');
			if ($reviewWidget) {
				window.scroll({
					top: $reviewWidget.offsetTop,
					behavior: 'smooth'
				})
			}
		})
	}

	const ProductReviewAnchor = () => {

		const targetNode = document.querySelector(".yotpo-review-rating");

		const config = { attributes: true, childList: true, subtree: true };

		const callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if(mutation.type == 'childList') {
					document.querySelectorAll('.yotpo-review-rating').forEach(($btn) => {
						yotpoLinkClickHandler($btn);
					})
					observer.disconnect();
				}
			}
		};

		const observer = new MutationObserver(callback);

		if(targetNode) {
			observer.observe(targetNode, config);
		}

		document.querySelectorAll('.btn-view-review').forEach(($btn) => {
			// yotpoLinkClickHandler($btn);
          $btn.addEventListener('click', (e) => {
            e.preventDefault();
            let $reviewWidget = document.querySelector('[data-oke-widget]');
			if ($reviewWidget) {
				window.scroll({
					top: $reviewWidget.offsetTop,
					behavior: 'smooth'
				})
			}
          })
		})
	}


	const CollectionATC = () => {

		// Custom sort by

		document.addEventListener('change', (e) => {
			if(e.target.classList.contains('custom-sort-option')) {
				let collectionSortPopover = document.querySelector('#collection-sort-popover');
				if(collectionSortPopover) {
					collectionSortPopover.querySelector(`button.Popover__Value[data-value="${e.target.value}"]`).click();
				}
			}
		})

		document.querySelectorAll('.ProductItem__Wrapper .ProductForm__AddToCart').forEach(($atcButton) => {
			$atcButton.addEventListener('click', (e) => {
				e.preventDefault();

				var itemData = JSON.parse($atcButton.closest('.ProductItem').getAttribute('data-item-info'));

				var formElement = $atcButton.closest('form');
				var card = $atcButton.closest('.ProductItem__Wrapper');

				let props = {};
				formElement.querySelectorAll('input[name^="properties"]').forEach((prop) => {
					let prop_name = prop.getAttribute('name').replace('properties[', '').replace(']', '');
					props[prop_name] = prop.value;
				})

				let rcOpt = {};
				if(card.querySelector('.Product__RechargeInfo.enabled')) {
					let rcOptEl = card.querySelector('.Product__RechargeInfo select');
					rcOpt = {
						selling_plan: rcOptEl.value,
						[`selling_plan_${rcOptEl.value}`]: 'subsave'
					}
				}

				var formData = {
					'items': [{
						'id': formElement.querySelector('select').value,
						'quantity': 1,
						'properties': props,
						...rcOpt
					}]
				};

				fetch(window.Shopify.routes.root + 'cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(formData)
				})
					.then(function (response) {
						document.dispatchEvent(new CustomEvent('theme:loading:end'));
						if (response.ok) {
							$atcButton.closest('section').dispatchEvent(new CustomEvent('product:added', {
								bubbles: true,
								detail: {
									variant: formElement.querySelector('select').value,
									quantity: 1
								}
							}));

							var promoData = {
								'promotion_name': window.globalPromotionName,
								'promotion_id': window.globalPromotionId
							}
							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({ ecommerce: null });
							window.dataLayer.push({
								event: 'custom_add_to_cart',
								'user_id': window.user_id,
								'user_type': window.user_type,
								'hit_time_stamp': new Date().toLocaleString(),
								...promoData,
								'ecommerce': {
									'currency': window.shop_currency,
									'items': itemData
								}
							});

						}
						else {
						}
					});
			})
		})
	}

	const CartNote = () => {
		const $drawerCart = document.querySelector('#sidebar-cart');
		if (!$drawerCart) {
			return;
		}
		$drawerCart.addEventListener('click', (e) => {
			// console.log(e.target);
			if (e.target.classList.contains('cart-note-save')) {
				e.target.closest('.Cart__OffscreenNoteContainer').classList.add('hidden');
			}
		})
	}

	const TextVideoSetHeight = () => {
		if (!isMobile()) {
			document.querySelectorAll('.section-text-with-video').forEach(($section) => {
				const $media = $section.querySelector('.layout-default .media-wrapper');
				if ($media) {
					const mediaHeight = $media.offsetHeight;
					console.log(mediaHeight);
					$section.querySelector('.content').style.height = `${mediaHeight}px`;
				}
			})
		}
	}

	const TextImageReadMore = () => {
		if (isMobile()) {
			document.querySelectorAll('.section-text-with-video').forEach(($section) => {
				const $content = $section.querySelector('.content');
				if ($content) {
					if ($content.offsetHeight > 250) {
						const $readmore = $section.querySelector('.read-more');
						$readmore.classList.remove('hidden');
						$content.classList.add('overflow');

						$readmore.addEventListener('click', () => {
							if ($readmore.getAttribute('data-collapsed') == 'true') {
								$readmore.setAttribute('data-collapsed', 'false');
								$readmore.innerHTML = 'Read less';
								$content.classList.remove('overflow');
							}
							else {
								$readmore.setAttribute('data-collapsed', 'true');
								$readmore.innerHTML = 'Read more';
								$content.classList.add('overflow');
							}
						})
					}
				}
			})
		}
	}

	const ProductPriceChange = () => {
		
		const targetNode = document.querySelector(".rc-widget-injection-parent");

		const config = { attributes: true, childList: true, subtree: true };

		const callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if(mutation.attributeName == 'class') {
					let targetClass = mutation.target.classList;
					if(targetClass.contains('rc-option--active')) {
						setTimeout(() => {
							// let $price = document.querySelector('.Product__Wrapper .ProductMeta__Price');
                            let $price = mutation.target.querySelector('.rc-option__price');

							let btn_label = 'Add to cart';
							if(targetClass.contains('rc-option__subsave')) {
								btn_label = 'Subscribe';
							}

							const $btnLabel = document.querySelector('.Product__Wrapper .ProductForm__BuyButtons .btn__label');
							const $btnPrice = document.querySelector('.Product__Wrapper .ProductForm__BuyButtons .btn__price');

							if($btnLabel.dataset.preorder == 'true') {
								btn_label = window.languages.preorderLabel;
							}

							if($btnLabel) {
								$btnLabel.innerHTML = btn_label;
							}
							if($btnPrice && $price) {
								let btn_price = $price.innerHTML;
								$btnPrice.innerHTML = btn_price;
							}
						});
					}
				}
			}
		};

		const observer = new MutationObserver(callback);

		if(targetNode) {
			observer.observe(targetNode, config);
		}

		// observer.disconnect();

	}

	const ProductSellingPlanItem = () => {
		$('.product-form-subscribe-trigger').each((i, $button) => {
			let wrapper = $($button).closest('.ProductForm__BuyButtons');
			if ($button.classList.contains('has-variant')) {
				$($button).on('mouseover', (e) => {
					wrapper.toggleClass('show-variants', true);
				});
				$(wrapper).on('mouseleave', (e) => {
					wrapper.toggleClass('show-variants', false);
				});
			} else {
				//
			}
		});

		let planForm = document.querySelectorAll('.Product__SellingPlans');

		planForm.forEach((_planForm) => {
			let subscribeBtn = $(_planForm).find('.subscribe-input');
			let subscribePlans = $(_planForm).find('.subscribe-plans');
			let subscribePlanInput = $(_planForm).find('#subscribe-plan');

			subscribeBtn.on('click', () => {
				subscribeBtn.toggleClass('show');
			});

			subscribePlans.children('li').each((i, n) => {
				$(n).on('click', () => {
					let id = $(n).attr('data-option-id');
					let name = $(n).attr('data-option-name');
					subscribePlanInput.val(id);
					subscribeBtn.html(name);
					subscribeBtn[0].classList.remove('show');
				});
			});

			document.addEventListener('click', (e) => {
				if (!subscribePlans[0].contains(e.target) && !subscribeBtn[0].contains(e.target)) {
					subscribeBtn[0].classList.remove('show');
				}
			});

			$(_planForm).find('.product-form-subscribe-trigger').on('click', (e) => {
				$(e.target).closest('.ProductForm__BuyButtons').find('.product-variants li:not(.disabled)').eq(0).click();
			})
		})

		$('#product-form-subscribe-wrapper .product-variants li').each((i, v) => {
			$(v).on('click', () => {
				let id = $(v).attr('data-variant-id');
				// let subscribePlan = subscribePlanInput.val();
				let subscribePlan = $(v).closest('.Product__SellingPlans').find('#subscribe-plan').val();
				console.log(subscribePlan);
				addItemToCart(v, id, 1, subscribePlan);
			});
		});

		function addItemToCart($node, variant_id, qty, subscribePlan) {
			data = {
				id: variant_id,
				quantity: qty,
				selling_plan: subscribePlan,
			};
			jQuery.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: data,
				dataType: 'json',
				success: function () {
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
					$node.closest('section').dispatchEvent(
						new CustomEvent('product:added', {
							bubbles: true,
							detail: {},
						})
					);
				},
			});
		}

	}

	const SearchSpringFilterToggle = () => {
		let pageOverlayEl = document.querySelector('.PageOverlay');
		let filterToggleBtn = document.querySelector('.filter-toggle-button')
		if(filterToggleBtn) {
			filterToggleBtn.addEventListener('click', () => {
				document.body.classList.toggle('filter-open');
				if(isMobile()) {
					// Search Spring 
					pageOverlayEl.classList.add('is-visible');
					pageOverlayEl.addEventListener('click', () => {
						pageOverlayEl.classList.remove('is-visible');
						document.body.classList.remove('filter-open');
						// pageOverlayEl.removeEventListener('click');
					});
					// Default theme
					let filterToggle = document.querySelector('.CollectionToolbar__Item--filter');
					if(filterToggle) {
						filterToggle.click();
					}
				}
			})
		}
	}

	const TargetScroll = () => {
		var url = location.href;
		if(url.includes('#')) {
			var target = document.querySelector(`#${url.split('#')[1]}`);
			if(target) {
				var posTop = target.offsetTop;
				if(ThemeFunc.isMobile()) {
					posTop += 200;
				}
				else {
					posTop += 350;
				}
				window.scrollTo({top: posTop, behavior: 'smooth'});
			}
		}
	}

	const ProductItemHoverVideo = () => {
		document.querySelectorAll('.ProductItem__Wrapper .AspectRatio.hover-video').forEach((wrapper) => {
			let video = wrapper.querySelector('video');
			wrapper.addEventListener('mouseover', () => {
				video.play();
			})
			wrapper.addEventListener('mouseleave', () => {
				video.pause();
			})
		})
	}

	const ProductCFM = () => {

		if(window.template != 'product') {
			return;
		}
      
		// var cfm_options = {
		// 	clientName: clientName,
		// 	validationToken: validationToken,
		// 	sku: cfmSKU
		// }

		// var el = {
		// 	ingSelectedTitle: '[data-ingredient-selected-title]',
		// 	ingSelectedContent: '[data-ingredient-selected-content]',
		// 	ingList: '[data-ingredient-list]'
		// }

		// function initCFM() {
		// 	var url = `https://clickable-api.clearforme.com/api/app/products/details/v2?clientname=${cfm_options.clientName}&&sku=${cfm_options.sku}`;
		// 	fetch(url, {
		// 		headers: {
		// 			'Content-Type': 'application/json',
		// 			'Authorization': `Bearer ${cfm_options.validationToken}`,
		// 		}
		// 	}).then(res => res.json())
		// 	.then((response) => {
		// 			var ingListStr = '';
		// 			if(!response.productIngredients) {
		// 					return;
		// 			}
		// 			response.productIngredients.forEach((pIngredients) => {
		// 				pIngredients.ingredientGroup.forEach((fGroup) => {
		// 					fGroup.ingredients.forEach((ingredient, idx) => {
		// 						// ingListStr += `<span class="${idx == 0 ? 'active': ''}" data-ingredient="${ingredient.ingredientName}" data-p-ingredient-id="${ingredient.productIngredientId}" data-cfmIngredientId="${ingredient.cfmIngredientId}">${ingredient.ingredientName}</span>, `;
		// 						ingListStr += `<span class="" data-ingredient="${ingredient.ingredientName}" data-p-ingredient-id="${ingredient.productIngredientId}" data-cfmIngredientId="${ingredient.cfmIngredientId}">${ingredient.ingredientName}</span>, `;
		// 						if(idx == 0) {
		// 							// getIngItem(ingredient.ingredientName, ingredient.productIngredientId, ingredient.cfmIngredientId);
		// 						}
		// 					})
		// 				})
		// 			})
		// 			ingListStr = ingListStr.slice(0, -2);
		// 			document.querySelector(el.ingList).innerHTML = ingListStr;
		// 			document.querySelectorAll(`${el.ingList} span`).forEach((ingBtn) => {
		// 				ingBtn.addEventListener('click', () => {
		// 					getIngItem(ingBtn.dataset.ingredient, ingBtn.dataset.pIngredientId, ingBtn.dataset.cfmingredientid);
		// 					document.querySelector(`${el.ingList} span.active`).classList.remove('active');
		// 					ingBtn.classList.add('active');
		// 				})
		// 			})
		// 	})
		// }

		// function getIngItem(ingredientName, productIngredientId, cfmiId) {
		// 	var url = `https://clickable-api.clearforme.com/api/app/ingredients/definition/v2?clientname=${cfm_options.clientName}&productIngredientId=${productIngredientId}&cfmIngredientId=${cfmiId}`;
		// 	fetch(url, {
		// 		headers: {
		// 			'Content-Type': 'application/json',
		// 			'Authorization': `Bearer ${cfm_options.validationToken}`,
		// 		}
		// 	}).then(res => res.json())
		// 	.then((response) => {
		// 		document.querySelector(el.ingSelectedTitle).innerHTML = ingredientName;
		// 		document.querySelector(el.ingSelectedContent).innerHTML = `
		// 			<p>
		// 				<strong>Definition: </strong> ${response.definition}
		// 			</p>
		// 			<p>
		// 				<strong>Purpose: </strong> ${response.functions.map((item) => {
		// 					return item.attribute;
		// 				}).join(', ')}
		// 			</p>
		// 		`;
		// 	})
		// }
		// initCFM();
	}

	const videoHoverPlay = () => {
		document.querySelectorAll('.embed-wrapper.hover-play').forEach((embed) => {
			var $iframe = embed.querySelector('iframe');
			var $video = embed.querySelector('video');
			if (!isMobile()) {
				if ($iframe) {
					$iframe.addEventListener('mouseover', () => {
						var src = $iframe.getAttribute('src');
						if (!src.includes('autoplay')) {
							if (src.includes('?')) {
								src += '&autoplay=1';
							}
							else {
								src += '?autoplay=1'
							}
							// if (!src.includes('muted=1')) {
							// 	src += '&muted=1';
							// }
						}
						$iframe.setAttribute('src', src);
					})
				}
				if ($video) {
					$video.addEventListener('mouseover', () => {
						$video.play();
					})
				}
			}
		})
	}

	return {
		isMobile: isMobile,
		IconTextSlider: IconTextSlider,
		VideoInviewPlay: VideoInviewPlay,
		ProductStickyATC: ProductStickyATC,
		ProductStickyATCTrigger: ProductStickyATCTrigger,
		SideMenuPos: SideMenuPos,
		ProductItemATC: ProductItemATC,
		CollapseAccountNav: CollapseAccountNav,
		ProductReviewAnchor: ProductReviewAnchor,
		CollectionATC: CollectionATC,
		CartNote: CartNote,
		PredictiveSearch: PredictiveSearch,
		TextVideoSetHeight: TextVideoSetHeight,
		TextImageReadMore: TextImageReadMore,
		ProductPriceChange: ProductPriceChange,
		ProductSellingPlanItem: ProductSellingPlanItem,
		SearchSpringFilterToggle: SearchSpringFilterToggle,
		ProductItemHoverVideo: ProductItemHoverVideo,
		TargetScroll: TargetScroll,
		ProductCFM: ProductCFM,
		videoHoverPlay: videoHoverPlay
	}

}();

ThemeFunc.VideoInviewPlay();
ThemeFunc.IconTextSlider();
ThemeFunc.ProductStickyATC();
ThemeFunc.ProductStickyATCTrigger();
ThemeFunc.SideMenuPos();
ThemeFunc.ProductItemATC(null, true);
ThemeFunc.CollectionATC();
ThemeFunc.CollapseAccountNav();
ThemeFunc.ProductReviewAnchor()
ThemeFunc.CartNote();
// ThemeFunc.PredictiveSearch();
ThemeFunc.TextVideoSetHeight();
ThemeFunc.TextImageReadMore();
ThemeFunc.ProductPriceChange();
ThemeFunc.ProductSellingPlanItem();
ThemeFunc.SearchSpringFilterToggle();
ThemeFunc.ProductCFM();
ThemeFunc.videoHoverPlay();
ThemeFunc.ProductItemHoverVideo();

document.addEventListener('scroll', (event) => {
	ThemeFunc.VideoInviewPlay();
	ThemeFunc.SideMenuPos(event);
	ThemeFunc.ProductStickyATC(event);
})

document.addEventListener("DOMContentLoaded", (event) => {
	setTimeout(() => {
		ThemeFunc.TargetScroll();
	}, 1500);
});

// update rebuy cart drawer UI 
const carouselContent = `
    <div class="carousel-cell">
      <img style="width:76px;" 
       src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/afterpay.png?v=1709855783"
       data-src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/afterpay.png?v=1709855783"
       alt="afterpay icon" loading="lazy">
      <span style="margin-bottom:2px;">4 interest-free payments of <span id="afterpay-amount">0</span></span>
     </div>
    <div class="carousel-cell">
      <img src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/free_sample.svg?v=1709855476" 
      data-src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/free_sample.svg?v=1709855476"
      alt="free sample icon" loading="lazy">
      <span>Free sample with every order</span>
    </div>
    <div class="carousel-cell">
      <img src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/free_shipping.svg?v=1709855475" 
      data-src="https://cdn.shopify.com/s/files/1/0112/4581/3841/files/free_shipping.svg?v=1709855475"
      alt="free shipping icon" loading="lazy">
      <span>Free shipping on all orders</span>
    </div>
    `;

function rebuyCartDrawerUpdates() {
  function isRebuyCartRendered(mutationsList, observer) {
    for (const mutation of mutationsList) {
        for (const node of mutation.addedNodes) {
            if (node instanceof Element && node.tagName === 'GIFTNOTE-BUTTON') {
                const shadowRoot = node.shadowRoot;
                const giftMessageBtn = shadowRoot?.querySelector('#button');
                if (giftMessageBtn) {
                    giftMessageBtn.querySelector("#add").textContent = "Add a Gift Message";
                    giftMessageBtn.style.cssText = `
                        font-family: "sofia-pro", sans-serif;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 14px;
                        letter-spacing: 0em;
                        text-align: left;
                        color: #363636;
                        text-decoration: underline;
                        background: transparent;
                        border: none;
                        height: 32px;
                        position: relative;
                        padding-left: 28px;
                    `;
                    
                    const giftIcon = document.createElement('img');
                    giftIcon.src = 'https://cdn.shopify.com/s/files/1/0112/4581/3841/files/cart-gift-icon.svg?v=1709701536';
                    giftIcon.alt = 'Gift Icon';
                    giftIcon.style.cssText = `
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    `;
                    giftMessageBtn.insertBefore(giftIcon, giftMessageBtn.firstChild);

                    renderCarouselContainer();
                    initCarousel();
                    handleAfterpayAmountUpdate();
                    observer.disconnect();
                }
            }
        }
    }
}

function renderCarouselContainer() {
    const rebuyContainer = document.querySelector(".rebuy-cart__flyout");
    if (rebuyContainer) {
        const customCarousel = document.createElement("div");
        customCarousel.className = "cart-dw-carousel";
        customCarousel.innerHTML = carouselContent;
        rebuyContainer.appendChild(customCarousel);
    }
}

function initCarousel() {
  const flkty = new Flickity('.cart-dw-carousel', {
    contain: true, 
    wrapAround: true,
    pageDots: false,
    autoPlay: 3000,
  });
}

function handleAfterpayAmountUpdate() {
    const Cart = window.Rebuy.Cart;
    const afterpayAmount = document.querySelector("#afterpay-amount");
    const updateAfterpayAmount = () => {
        afterpayAmount.textContent = Cart.formatMoney(Cart.subtotal() / 4);
    };

    updateAfterpayAmount();
    document.addEventListener('rebuy:cart.change', updateAfterpayAmount);
}

const observer = new MutationObserver(isRebuyCartRendered);
observer.observe(document.body, { childList: true, subtree: true });
 }
rebuyCartDrawerUpdates();


$(document).ready(function() {
if($(".siteWideSaleItem").length)
{ 
  function show20off(tttint) {
    setTimeout(
    function() 
    {
      //console.log("triggered");
      if(!$("#product-atc .btn__price .compare-price").length)
      {
      var price = $("#product-atc .btn__price").html();
      var priceval = price.replace("$","");
        priceval = parseFloat(priceval);
        var discprice = priceval * 0.7;
        discprice = discprice.toFixed(2);
        var html ='<span class="compare-price">'+price+'</span> $'+discprice;
        $("#product-atc .btn__price").html(html);
      }
    }, tttint);
  }
  
  $(document).on('change',".ProductForm",function() {
    
    show20off(1000);
     
  });

  $(document).on('change',".rc-widget-injection-parent",function() {
    
    show20off(1000);
     
  });

  
  show20off(7000);
}
  
  
});

